import React, { useState, useEffect } from "react";
import CssCodeEditor from "../../../components/CssCodeEditor";

const StyleTab = ({ handleLayoutChange, selectedLayout,updatePhotoGalleryTabData,photoGalleryTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(photoGalleryTabData.custom_css);

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updatePhotoGalleryTabData("custom_css", code);
    };
    
    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);
    
    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                            <span>Style Options</span>
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("testing")}>Testing<i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "testing" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Testing</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Testing Options</span>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 
        </div>
    );
};

export default StyleTab;